// src/features/media/useTranscodeVods.ts

import { useQuery } from '@tanstack/react-query';
import { MediaApi } from './MediaApi';
import { useAuth } from '@/features/auth/hooks/useAuth';

export const TRANSCODE_VOD_QUERY_KEYS = {
  all: ['transcodeVod'] as const,
  list: (cId: number) => [...TRANSCODE_VOD_QUERY_KEYS.all, 'list', cId] as const,
} as const;

/**
 * Hook for fetching transcode VOD presets.
 * Used for quality selection in clip tool.
 */
export function useTranscodeVods() {
  const { selectedCId } = useAuth();

  return useQuery({
    queryKey: TRANSCODE_VOD_QUERY_KEYS.list(selectedCId ?? 0),
    queryFn: () => MediaApi.getTranscodeVods(selectedCId!),
    enabled: selectedCId != null,
    staleTime: 10 * 60 * 1000, // 10 minutes - rarely changes
  });
}
